const skyA = {
  skyA1: "hsla(190, 100%, 51.0%, 0.024)",
  skyA2: "hsla(193, 100%, 50.1%, 0.055)",
  skyA3: "hsla(193, 100%, 50.1%, 0.106)",
  skyA4: "hsla(194, 99.6%, 47.7%, 0.165)",
  skyA5: "hsla(194, 99.2%, 45.4%, 0.244)",
  skyA6: "hsla(194, 99.9%, 42.3%, 0.357)",
  skyA7: "hsla(194, 99.8%, 42.2%, 0.526)",
  skyA8: "hsla(193, 99.9%, 43.8%, 0.820)",
  skyA9: "hsla(193, 99.7%, 49.4%, 0.593)",
  skyA10: "hsla(193, 99.8%, 46.6%, 0.628)",
  skyA11: "hsla(196, 100%, 31.2%, 0.980)",
  skyA12: "hsla(196, 100%, 12.2%, 0.980)"
};
export { skyA };
//# sourceMappingURL=skyA.mjs.map
